import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { objectToParams } from 'app/constants';
import { AuthService } from 'app/shared/auth.service';
import { RestService } from 'app/shared/rest.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-two-step-modal',
    templateUrl: './two-step-modal.component.html',
    styleUrls: ['./two-step-modal.component.scss']
})
export class TwoStepModalComponent implements OnInit {
    twoStepVerification: FormGroup;
    dialogTitle: string = "Two Step Verification";
    IsDialogMax: boolean = false;
    hostHeight: any;
    hostWidth: any;
    otp: FormControl = new FormControl('', [Validators.required]);

    constructor(
        public matDialogRef: MatDialogRef<TwoStepModalComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        public _matDialog: MatDialog,
        private _fuseSplashScreenService: FuseSplashScreenService,
        private _restService: RestService,
        private _auth: AuthService,
        private _toastr: ToastrService,
    ) {}

    ngOnInit() {
        this.twoStepVerification = this._formBuilder.group({
            otp: [''],
        });


    }

    verifyCode() {
        if (this.matDialogRef && this.otp.valid) {
            var res = {
                event: this._data.event,
                code: this.otp.value
            }
            this.matDialogRef.close(res);
        }else{
            this._toastr.error("Please enter verification code");
        }
    }
    resendOTP() {
        if (this.matDialogRef && this.otp.valid) {
            var res = {
                event: this._data.event,
                code: ""
            }
            this.matDialogRef.close(res);
        }
    }

    minimizeDialog() {
        let elements: any = document.getElementsByClassName("twostepdialog");
        for (var i = 0; i < elements.length; i++) {
            elements[i].style.width = (this.hostWidth + 1 + 'px');
            elements[i].style.height = (this.hostHeight + 1 + 'px');
        }
        document.getElementById("two-way-content").style.maxHeight = "65vh";
        document.getElementById("two-way-wrapper").style.maxHeight = "85vh";
        this.IsDialogMax = !this.IsDialogMax;
    }
    maximizeDialog() {
        let elements: any = document.getElementsByClassName("twostepdialog");
        for (var i = 0; i < elements.length; i++) {
            this.hostHeight = elements[i].clientHeight;
            this.hostWidth = elements[i].clientWidth;
            elements[i].style.width = ("100%");
            elements[i].style.height = ("100%");
        }
        document.getElementById("two-way-content").style.maxHeight = "100vh";
        document.getElementById("two-way-wrapper").style.maxHeight = "100vh";
        this.IsDialogMax = !this.IsDialogMax;
    }

}
